import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteDisasterEvent($id: ID!) {
        deleteEvent(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
